import { Spinner } from "@@common";
import { Stack } from "@mui/material";
import React, { useContext } from "react";
import ConfigContext from "../../../components/ConfigContext";
import EmbedLoading from "../../../embedding/EmbedLoading";
import { useComponentSelection } from "../../Hooks/useComponentSelection";
import { ViewModel } from "../../Models/ViewModel";
import ComponentFactory from "../ComponentFactory";

type ViewBodyComponentProps = {
  isPending: boolean;
  children: any[];
  component: ViewModel;
  context: any;
  sx?: any;
  componentPath?: string[];
};

const ViewBodyComponent: React.FC<ViewBodyComponentProps> = ({ isPending, children, component, context, sx, componentPath = [] }) => {
  const configuration = useContext(ConfigContext);
  // Enable designer mode selection for this container
  const selectionProps = useComponentSelection({
    component,
    componentPath,
    isContainer: true,
    isEmpty: !children || children.length === 0,
  });

  return (
    <Stack direction="column" gap={2}
      sx={[...(Array.isArray(sx) ? sx : [sx]), configuration?.EMBED_FETCH && !component.Dialog ? { background: "transparent" } : false]}
      {...selectionProps}>
      {isPending && (configuration?.EMBED_FETCH ? <EmbedLoading /> : <Spinner />)}
      {!isPending &&
        children.map((child) => (
          <ComponentFactory key={child.Id} parent={component} component={child} context={context} componentPath={[...componentPath, child.Id]} />
        ))}
    </Stack>
  );
};

export default ViewBodyComponent;
